module.exports = __webpack_public_path__ + "img/yellowTwoBallon.680d121d.png";